import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Certificado } from 'src/app/models/certificado';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CertificadoService {

  baseURL = environment.url;
  headers = new HttpHeaders({
    'apikey': environment.apptoken
  });

  // DEBUG - PRD
  //baseURL = 'https://api-integracao.estacioprd.net/v1/alunos';
  //headers = new HttpHeaders({
  //  client_id: '62e5d535df544e73b7284cd218c97be5',
  //  client_secret: 'c4d2F44d94AB423789AEf94b7B8524b9'
  //});

  constructor(
    private http: HttpClient
  ) { }

  // Lista as informações do certificado pesquisado
  getCertificado(codigo: string): Observable<Certificado> {
    return this.http.get<Certificado>(`${this.baseURL}/certificado/${codigo}`, {
      headers: this.headers
    });
  }

}
